module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"widget":{"expired":{"description":"The company’s Compliance subscription has expired"}},"notification":{"editLabel":"Editing is disabled. Employment info can only be edited by Employer."}}}')
  delete Component.options._Ctor
}
